<template>
  <Popper
    ref="popper"
    class="db-tooltip"
    v-bind="$attrs"
    hover
    arrow
    placement="top"
    :interactive="false"
    :show="hasFocus || isHovered"
  >
    <slot />
    <template v-slot:content="props">
      <span aria-hidden="true">
        <slot
          name="content"
          v-bind="props"
        />
      </span>
    </template>
  </Popper>
</template>

<script setup lang="ts">
import Popper from 'vue3-popper'
import { useFocusWithin, useElementHover } from '@vueuse/core'
import { ref, watch } from 'vue'

const popper = ref()
const hasFocus = ref<boolean>(false)
const isHovered = useElementHover(popper)
const { focused } = useFocusWithin(popper)

/** Popper don't handle focus state by default */
watch(focused, (focused) => {
  hasFocus.value = focused ? true : false
})
</script>

<style>
/* stylelint-disable */
.db-app .popper,
.db-app .popper[class*='fade'] {
  font-size: var(--db_small_body_text_font_size);
  transition: none !important;
  z-index: var(--db-zindex-tooltip);
}

/* Remove annoying fade dif between tooltip and arrow */
.db-app .popper #arrow,
.db-app .popper #arrow::before,
.db-app .popper[class*='fade'] #arrow,
.db-app .popper[class*='fade'] #arrow::before {
  transition: none !important;
}
/* stylelint-disable-enable */
</style>

<style scoped>
.db-app .db-tooltip {
  --popper-theme-background-color: var(--db_supporting_cta_background_color);
  --popper-theme-background-color-hover: var(--db_supporting_cta_background_color);
  --popper-theme-text-color: #ffffff;
  --popper-theme-padding: var(--db-spacer-12) var(--db-spacer-16);
  --popper-theme-box-shadow: 0px 1px 6px rga(0, 0, 0, 0.29);
}

.db-app .db-tooltip {
  line-height: 1;
}

.db-app .db-card-amenities .db-card-wrapper-amenities .db-list-details-icons-item .db-tooltip {
  font-family: var(--db_body_text_font_family);
  font-size: var(--db-font-size-12);
  font-weight: 500;
  color: var(--db_box_body_text_color);
}
</style>
